import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tx-land" }
const _hoisted_2 = {
  key: 0,
  class: "tx-land-note",
  role: "status"
}
const _hoisted_3 = { class: "tx-land-inner" }
const _hoisted_4 = { class: "tx-hero__text" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = ["placeholder", "aria-label"]
const _hoisted_8 = { class: "tx-btn tx-btn--primary" }
const _hoisted_9 = ["href", "data-nav"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "tx-land-h" }
const _hoisted_12 = {
  key: 0,
  class: "tx-land-sub"
}
const _hoisted_13 = { class: "tx-qa" }
const _hoisted_14 = ["href", "data-nav", "onClick"]
const _hoisted_15 = { class: "tx-qa__icon" }
const _hoisted_16 = { class: "tx-qa__text" }
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "tx-land-headrow" }
const _hoisted_19 = { class: "tx-land-h" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "tx-stats" }
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "tx-stat__n" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "tx-stat__n" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "tx-stat__n" }
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "tx-stat__n tx-stat__n--money" }
const _hoisted_30 = { class: "tx-land-headrow" }
const _hoisted_31 = { class: "tx-land-h" }
const _hoisted_32 = ["href"]
const _hoisted_33 = {
  key: 0,
  class: "tx-land-sub"
}
const _hoisted_34 = { class: "tx-land-list" }
const _hoisted_35 = ["href"]
const _hoisted_36 = { class: "tx-land-h" }
const _hoisted_37 = {
  key: 0,
  class: "tx-land-sub"
}
const _hoisted_38 = { class: "tx-land-chips" }
const _hoisted_39 = ["href"]
const _hoisted_40 = { class: "tx-land-headrow" }
const _hoisted_41 = { class: "tx-land-h" }
const _hoisted_42 = {
  key: 0,
  class: "tx-land-sub"
}
const _hoisted_43 = { class: "tx-land-grid" }
const _hoisted_44 = {
  key: 0,
  class: "tx-eyebrow"
}
const _hoisted_45 = {
  key: 1,
  class: "tx-muted"
}
const _hoisted_46 = ["href", "data-nav"]
const _hoisted_47 = { class: "tx-land-h" }
const _hoisted_48 = {
  key: 0,
  class: "tx-land-sub"
}
const _hoisted_49 = { class: "tx-faq" }
const _hoisted_50 = ["innerHTML"]
const _hoisted_51 = { class: "tx-land-h" }
const _hoisted_52 = {
  key: 0,
  class: "tx-land-sub"
}
const _hoisted_53 = { class: "tx-contact" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "tx-contact__dot" }, null, -1 /* HOISTED */)
const _hoisted_55 = { key: 0 }
const _hoisted_56 = {
  key: 0,
  class: "tx-contact__item"
}
const _hoisted_57 = { class: "tx-select" }
const _hoisted_58 = {
  key: 1,
  class: "tx-contact__item"
}
const _hoisted_59 = {
  class: "tx-select",
  dir: "ltr"
}
const _hoisted_60 = ["href"]
const _hoisted_61 = { class: "tx-land-announce" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = ["innerHTML"]
const _hoisted_64 = ["href", "data-nav"]
const _hoisted_65 = {
  key: 0,
  class: "tx-land-h"
}
const _hoisted_66 = {
  key: 1,
  class: "tx-land-sub"
}
const _hoisted_67 = { class: "tx-land-grid" }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = {
  key: 0,
  class: "tx-land-h"
}
const _hoisted_70 = ["innerHTML"]
const _hoisted_71 = { class: "tx-cta-band" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = ["href", "data-nav"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loader"], {
      loading: $setup.loading,
      error: $setup.error,
      onRetry: $setup.load
    }, {
      default: _withCtx(() => [
        (!$setup.state.isGuest && !$setup.state.linked)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($setup.state.t("land.unlinked")), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sections, (s, i) => {
          return (_openBlock(), _createElementBlock("section", {
            key: i,
            class: _normalizeClass(["tx-land-band", ['tx-land-band--' + (s.style || 'Plain').toLowerCase(), 'tx-land-' + $setup.slug(s.type)]])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createCommentVNode(" Hero "),
              (s.type === 'Hero')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["tx-hero", { 'tx-hero--image': s.image }])
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("h1", null, _toDisplayString(s.title || $setup.state.t("land.hero")), 1 /* TEXT */),
                      (s.subtitle)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(s.subtitle), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (s.search)
                        ? (_openBlock(), _createElementBlock("form", {
                            key: 1,
                            class: "tx-hero__search",
                            role: "search",
                            onSubmit: _withModifiers($setup.search, ["prevent"])
                          }, [
                            _createVNode($setup["Icon"], { name: "search" }),
                            _withDirectives(_createElementVNode("input", {
                              id: "tx-land-q",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.q) = $event)),
                              type: "search",
                              placeholder: $setup.state.t('land.search_ph'),
                              "aria-label": $setup.state.t('land.search')
                            }, null, 8 /* PROPS */, _hoisted_7), [
                              [
                                _vModelText,
                                $setup.q,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            _createElementVNode("button", _hoisted_8, _toDisplayString($setup.state.t("land.search")), 1 /* TEXT */)
                          ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_6))
                        : _createCommentVNode("v-if", true),
                      (s.button)
                        ? (_openBlock(), _createElementBlock("a", _mergeProps({
                            key: 2,
                            href: $setup.href(s.button.link),
                            class: "tx-btn tx-hero__btn"
                          }, $setup.extAttrs(s.button.link), {
                            "data-nav": $setup.isPortal(s.button.link) ? '' : null
                          }), _toDisplayString(s.button.label), 17 /* TEXT, FULL_PROPS */, _hoisted_9))
                        : _createCommentVNode("v-if", true)
                    ]),
                    (s.image)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: s.image,
                          alt: "",
                          class: "tx-hero__img"
                        }, null, 8 /* PROPS */, _hoisted_10))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */))
                : (s.type === 'Quick Actions')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createCommentVNode(" Quick actions "),
                      _createElementVNode("h2", _hoisted_11, _toDisplayString(s.title || $setup.state.t("land.actions")), 1 /* TEXT */),
                      (s.subtitle)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(s.subtitle), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.actions, (a) => {
                          return (_openBlock(), _createElementBlock("a", _mergeProps({
                            key: a.key,
                            href: $setup.actionHref(a),
                            class: "tx-qa__item"
                          }, a.key === 'whatsapp' ? { target: '_blank', rel: 'noopener' } : {}, {
                            "data-nav": $setup.actionNav(a) ? '' : null,
                            onClick: $event => ($setup.actionClick($event, a))
                          }), [
                            _createElementVNode("span", _hoisted_15, [
                              _createVNode($setup["Icon"], {
                                name: $setup.ACTION_ICON[a.key],
                                size: "22"
                              }, null, 8 /* PROPS */, ["name"])
                            ]),
                            _createElementVNode("span", _hoisted_16, [
                              _createElementVNode("strong", null, _toDisplayString($setup.qa(a.key)[0]), 1 /* TEXT */),
                              _createElementVNode("small", null, _toDisplayString($setup.qa(a.key)[1]), 1 /* TEXT */)
                            ]),
                            (a.login)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "tx-qa__lock",
                                  title: $setup.state.t('land.login_hint')
                                }, [
                                  _createVNode($setup["Icon"], {
                                    name: "login",
                                    size: "14"
                                  })
                                ], 8 /* PROPS */, _hoisted_17))
                              : _createCommentVNode("v-if", true)
                          ], 16 /* FULL_PROPS */, _hoisted_14))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
                  : (s.type === 'Account Summary')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createCommentVNode(" Account summary "),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("h2", _hoisted_19, _toDisplayString(s.title || $setup.state.t("land.summary")), 1 /* TEXT */),
                          _createElementVNode("a", {
                            href: $setup.link('dashboard'),
                            "data-nav": "",
                            class: "tx-link"
                          }, _toDisplayString($setup.state.t("land.go_dashboard")), 9 /* TEXT, PROPS */, _hoisted_20)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          ($setup.summary.tickets)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: $setup.link('tickets?status=Open'),
                                "data-nav": "",
                                class: "tx-stat"
                              }, [
                                _createElementVNode("span", _hoisted_23, _toDisplayString($setup.summary.tickets.open), 1 /* TEXT */),
                                _createElementVNode("span", null, _toDisplayString($setup.state.t("land.open_tickets")), 1 /* TEXT */)
                              ], 8 /* PROPS */, _hoisted_22))
                            : _createCommentVNode("v-if", true),
                          ($setup.summary.tickets)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: $setup.link('tickets?status=Paused'),
                                "data-nav": "",
                                class: "tx-stat tx-stat--warn"
                              }, [
                                _createElementVNode("span", _hoisted_25, _toDisplayString($setup.summary.tickets.waiting), 1 /* TEXT */),
                                _createElementVNode("span", null, _toDisplayString($setup.state.t("land.waiting")), 1 /* TEXT */)
                              ], 8 /* PROPS */, _hoisted_24))
                            : _createCommentVNode("v-if", true),
                          ($setup.summary.unread_messages !== undefined)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 2,
                                href: $setup.link('conversations'),
                                "data-nav": "",
                                class: "tx-stat"
                              }, [
                                _createElementVNode("span", _hoisted_27, _toDisplayString($setup.summary.unread_messages), 1 /* TEXT */),
                                _createElementVNode("span", null, _toDisplayString($setup.state.t("land.unread")), 1 /* TEXT */)
                              ], 8 /* PROPS */, _hoisted_26))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.summary.statement || [], (b) => {
                            return (_openBlock(), _createElementBlock("a", {
                              key: b.currency,
                              href: $setup.link('account?tab=statement'),
                              "data-nav": "",
                              class: _normalizeClass(["tx-stat", { 'tx-stat--danger': b.overdue > 0 }])
                            }, [
                              _createElementVNode("span", _hoisted_29, _toDisplayString($setup.fmtMoney(b.outstanding, b.currency)), 1 /* TEXT */),
                              _createElementVNode("span", null, _toDisplayString($setup.state.t("land.outstanding")), 1 /* TEXT */)
                            ], 10 /* CLASS, PROPS */, _hoisted_28))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : (s.type === 'Popular Articles')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createCommentVNode(" Popular articles "),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("h2", _hoisted_31, _toDisplayString(s.title || $setup.state.t("land.articles")), 1 /* TEXT */),
                            _createElementVNode("a", {
                              href: $setup.link('knowledge'),
                              "data-nav": "",
                              class: "tx-link"
                            }, _toDisplayString($setup.state.t("land.view_all")), 9 /* TEXT, PROPS */, _hoisted_32)
                          ]),
                          (s.subtitle)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(s.subtitle), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("div", _hoisted_34, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.articles, (a) => {
                              return (_openBlock(), _createElementBlock("a", {
                                key: a.name,
                                href: $setup.link('knowledge/' + a.name),
                                "data-nav": "",
                                class: "tx-land-article"
                              }, [
                                _createVNode($setup["Icon"], {
                                  name: "book",
                                  size: "18"
                                }),
                                _createElementVNode("span", null, [
                                  _createElementVNode("strong", null, _toDisplayString(a.title), 1 /* TEXT */),
                                  _createElementVNode("small", null, _toDisplayString(a.excerpt), 1 /* TEXT */)
                                ])
                              ], 8 /* PROPS */, _hoisted_35))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ], 64 /* STABLE_FRAGMENT */))
                      : (s.type === 'Knowledge Categories')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _createCommentVNode(" Categories "),
                            _createElementVNode("h2", _hoisted_36, _toDisplayString(s.title || $setup.state.t("land.categories")), 1 /* TEXT */),
                            (s.subtitle)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(s.subtitle), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_38, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.categories, (c) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  key: c.name,
                                  href: $setup.link('knowledge?category=' + encodeURIComponent(c.name)),
                                  "data-nav": "",
                                  class: "tx-land-chip"
                                }, _toDisplayString(c.label), 9 /* TEXT, PROPS */, _hoisted_39))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ], 64 /* STABLE_FRAGMENT */))
                        : (s.type === 'Services')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                              _createCommentVNode(" Services "),
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("h2", _hoisted_41, _toDisplayString(s.title || $setup.state.t("land.services")), 1 /* TEXT */)
                              ]),
                              (s.subtitle)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(s.subtitle), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("div", _hoisted_43, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.services, (x) => {
                                  return (_openBlock(), _createElementBlock("article", {
                                    key: x.name,
                                    class: "tx-land-card"
                                  }, [
                                    (x.category)
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_44, _toDisplayString(x.category), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    _createElementVNode("strong", null, _toDisplayString(x.name), 1 /* TEXT */),
                                    _createElementVNode("p", null, _toDisplayString(x.description), 1 /* TEXT */),
                                    (x.response_target)
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_45, [
                                          _createVNode($setup["Icon"], {
                                            name: "clock",
                                            size: "13"
                                          }),
                                          _createTextVNode(" " + _toDisplayString(x.response_target), 1 /* TEXT */)
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    _createElementVNode("a", {
                                      href: $setup.state.isGuest || !$setup.state.linked ? $setup.loginUrl($setup.base + '/services') : $setup.link('services'),
                                      "data-nav": $setup.state.isGuest || !$setup.state.linked ? null : '',
                                      class: "tx-link"
                                    }, _toDisplayString($setup.state.t("land.request")) + " →", 9 /* TEXT, PROPS */, _hoisted_46)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ], 64 /* STABLE_FRAGMENT */))
                          : (s.type === 'FAQ')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                _createCommentVNode(" FAQ "),
                                _createElementVNode("h2", _hoisted_47, _toDisplayString(s.title || $setup.state.t("land.faq")), 1 /* TEXT */),
                                (s.subtitle)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(s.subtitle), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("div", _hoisted_49, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.faq, (f, j) => {
                                    return (_openBlock(), _createElementBlock("details", {
                                      key: j,
                                      class: "tx-faq__item"
                                    }, [
                                      _createElementVNode("summary", null, _toDisplayString(f.q), 1 /* TEXT */),
                                      _createElementVNode("div", {
                                        class: "tx-prose",
                                        innerHTML: f.a
                                      }, null, 8 /* PROPS */, _hoisted_50)
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ])
                              ], 64 /* STABLE_FRAGMENT */))
                            : (s.type === 'Contact and Hours')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                  _createCommentVNode(" Contact and hours "),
                                  _createElementVNode("h2", _hoisted_51, _toDisplayString(s.title || $setup.state.t("land.contact")), 1 /* TEXT */),
                                  (s.subtitle)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(s.subtitle), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                  _createElementVNode("div", _hoisted_53, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["tx-contact__status", { on: s.contact.online }])
                                    }, [
                                      _hoisted_54,
                                      _createElementVNode("strong", null, _toDisplayString(s.contact.online ? $setup.state.t("land.online") : $setup.state.t("land.offline")), 1 /* TEXT */),
                                      (s.contact.days.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString($setup.hours(s.contact)), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                      (s.contact.chat)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            type: "button",
                                            class: "tx-btn tx-btn--primary tx-btn--sm",
                                            onClick: _cache[1] || (_cache[1] = $event => ($setup.openChat()))
                                          }, _toDisplayString($setup.state.t("land.chat_now")), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                    ], 2 /* CLASS */),
                                    (s.contact.email)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                          _createVNode($setup["Icon"], { name: "mail" }),
                                          _createElementVNode("span", null, [
                                            _createElementVNode("small", null, _toDisplayString($setup.state.t("land.email")), 1 /* TEXT */),
                                            _createElementVNode("span", _hoisted_57, _toDisplayString(s.contact.email), 1 /* TEXT */)
                                          ])
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (s.contact.phone)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                          _createVNode($setup["Icon"], { name: "phone" }),
                                          _createElementVNode("span", null, [
                                            _createElementVNode("small", null, _toDisplayString($setup.state.t("land.phone")), 1 /* TEXT */),
                                            _createElementVNode("span", _hoisted_59, _toDisplayString(s.contact.phone), 1 /* TEXT */)
                                          ])
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (s.contact.whatsapp)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 2,
                                          href: s.contact.whatsapp,
                                          target: "_blank",
                                          rel: "noopener",
                                          class: "tx-contact__item tx-contact__item--link"
                                        }, [
                                          _createVNode($setup["Icon"], { name: "whatsapp" }),
                                          _createElementVNode("span", null, [
                                            _createElementVNode("small", null, _toDisplayString($setup.state.t("land.whatsapp")), 1 /* TEXT */),
                                            _createElementVNode("span", null, _toDisplayString($setup.state.t("land.qa.whatsapp")[0]), 1 /* TEXT */)
                                          ])
                                        ], 8 /* PROPS */, _hoisted_60))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ], 64 /* STABLE_FRAGMENT */))
                              : (s.type === 'Announcement')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                    _createCommentVNode(" Announcement "),
                                    _createElementVNode("div", _hoisted_61, [
                                      _createVNode($setup["Icon"], { name: "bell" }),
                                      _createElementVNode("div", null, [
                                        (s.title)
                                          ? (_openBlock(), _createElementBlock("strong", _hoisted_62, _toDisplayString(s.title), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true),
                                        _createElementVNode("div", {
                                          class: "tx-prose",
                                          innerHTML: s.html
                                        }, null, 8 /* PROPS */, _hoisted_63),
                                        (s.button)
                                          ? (_openBlock(), _createElementBlock("a", _mergeProps({
                                              key: 1,
                                              href: $setup.href(s.button.link),
                                              class: "tx-link"
                                            }, $setup.extAttrs(s.button.link), {
                                              "data-nav": $setup.isPortal(s.button.link) ? '' : null
                                            }), _toDisplayString(s.button.label) + " →", 17 /* TEXT, FULL_PROPS */, _hoisted_64))
                                          : _createCommentVNode("v-if", true)
                                      ])
                                    ])
                                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                : (s.type === 'Cards')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                      _createCommentVNode(" Cards "),
                                      (s.title)
                                        ? (_openBlock(), _createElementBlock("h2", _hoisted_65, _toDisplayString(s.title), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                      (s.subtitle)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_66, _toDisplayString(s.subtitle), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("div", _hoisted_67, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.cards, (c, j) => {
                                          return (_openBlock(), _createBlock(_resolveDynamicComponent(c.link ? 'a' : 'article'), _mergeProps({
                                            key: j,
                                            class: ["tx-land-card", { 'tx-land-card--link': c.link }],
                                            href: c.link ? $setup.href(c.link) : null
                                          }, c.link ? $setup.extAttrs(c.link) : {}, {
                                            "data-nav": c.link && $setup.isPortal(c.link) ? '' : null
                                          }), {
                                            default: _withCtx(() => [
                                              _createElementVNode("strong", null, [
                                                _createTextVNode(_toDisplayString(c.title) + " ", 1 /* TEXT */),
                                                (c.link && $setup.isExternal(c.link))
                                                  ? (_openBlock(), _createBlock($setup["Icon"], {
                                                      key: 0,
                                                      name: "external",
                                                      size: "13"
                                                    }))
                                                  : _createCommentVNode("v-if", true)
                                              ]),
                                              (c.text)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_68, _toDisplayString(c.text), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["class", "href", "data-nav"]))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ])
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : (s.type === 'Custom Content')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                                        _createCommentVNode(" Custom content "),
                                        (s.title)
                                          ? (_openBlock(), _createElementBlock("h2", _hoisted_69, _toDisplayString(s.title), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true),
                                        _createElementVNode("div", {
                                          class: "tx-prose tx-land-custom",
                                          innerHTML: s.html
                                        }, null, 8 /* PROPS */, _hoisted_70)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : (s.type === 'Call to Action')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                                          _createCommentVNode(" Call to action "),
                                          _createElementVNode("div", _hoisted_71, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("h2", null, _toDisplayString(s.title), 1 /* TEXT */),
                                              (s.subtitle)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_72, _toDisplayString(s.subtitle), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                            ]),
                                            (s.button)
                                              ? (_openBlock(), _createElementBlock("a", _mergeProps({
                                                  key: 0,
                                                  href: $setup.href(s.button.link),
                                                  class: "tx-btn tx-cta-band__btn"
                                                }, $setup.extAttrs(s.button.link), {
                                                  "data-nav": $setup.isPortal(s.button.link) ? '' : null
                                                }), _toDisplayString(s.button.label), 17 /* TEXT, FULL_PROPS */, _hoisted_73))
                                              : _createCommentVNode("v-if", true)
                                          ])
                                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                      : _createCommentVNode("v-if", true)
            ])
          ], 2 /* CLASS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["loading", "error"])
  ]))
}